import { color } from '@upstox/upstox-ui';

export const headerContainer: CSSFunction = () => ({
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: '20px',
  justifyContent: 'space-between',
});

export const symbolInfo: CSSFunction = () => ({
  padding: '10px 0px 18px',
  justifyContent: 'space-between',
  gap: '16px',
  width: '100%',
});

export const symbolName: CSSFunction = ({ theme }) => ({
  fontWeight: 400,
  fontSize: '20px',
  color: color(theme, 'text.1'),
  textTransform: 'uppercase',
  fontFamily: theme.fonts.tvFont,
});

export const headerDataContainer: CSSFunction = ({ theme }) => ({
  width: '100%',
  color: color(theme, theme.colors.text[1]),
  gap: '28px',
});

export const dataContainer: CSSFunction = () => ({
  gap: '28px',
});

export const spotLabel: CSSFunction = ({ theme }) => ({
  fontWeight: 400,
  fontSize: '12px',
  color: color(theme, 'text.1'),
  marginRight: '4px',
  fontFamily: theme.fonts.tvFont,
});

export const lastTraded: CSSFunction = ({ theme }) => ({
  fontWeight: 400,
  fontSize: '16px',
  color: color(theme, 'text.1'),
  fontFamily: theme.fonts.tvFont,
});

export const settingsContainer: CSSFunction<{
  isOptionChainAvailable: boolean;
}> = ({ cssProps }) => {
  const { isOptionChainAvailable } = cssProps;
  return {
    alignItems: 'center',
    width: '380px',
    gap: '8px',
    justifyContent: 'flex-end',
    ...(!isOptionChainAvailable && {
      position: 'relative',
    }),
  };
};

export const expiryLabel: CSSFunction = ({ theme }) => ({
  marginRight: '12px',
  fontWeight: 400,
  fontSize: '12px',
  color: color(theme, 'text.1'),
});

export const expiryContainer: CSSFunction = () => ({
  alignItems: 'center',
  height: '28px',
  zIndex: 8,
  '> div > div': {
    minWidth: '170px',
    borderColor: 'none',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '4px',
    padding: '6px 4px 0px 16px',
    top: '28px !important',
  },
});

export const iconContainer: CSSFunction<{
  shiftToRight: boolean;
}> = ({ cssProps, theme }) => {
  const { shiftToRight } = cssProps;
  return {
    width: '28px',
    ...(shiftToRight && {
      position: 'absolute',
      right: '0px',
    }),
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${color(theme, theme.colors.ui3)}`,
    height: '28px',
  };
};

export const icon: CSSFunction<{ iconColor: string, isMinimized: boolean }> = ({
  cssProps,
  theme,
}) => {
  const { iconColor, isMinimized } = cssProps;
  return {
    width: '28px',
    height: '20px',
    cursor: isMinimized ? 'default' : 'pointer',
    color: color(theme, iconColor),
  };
};

export const dataHeading: CSSFunction = ({ theme }) => ({
  color: color(theme, theme.colors.text[2]),
  fontFamily: 'Trebuchet MS',
  fontSize: '12px',
  fontWeight: 400,
});

export const dataValue: CSSFunction = ({ theme }) => ({
  color: color(theme, theme.colors.text[1]),
  fontFamily: 'Trebuchet MS',
  fontSize: '16px',
  fontWeight: 400,
});
